import { render } from "./View612.vue?vue&type=template&id=03bc147a"
import script from "./View612.vue?vue&type=script&lang=js"
export * from "./View612.vue?vue&type=script&lang=js"

import "./View612.vue?vue&type=style&index=0&id=03bc147a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__